export default __webpack_public_path__ + "static/media/NotoSansKR-Light.582c4b5f.ttf";